import {Outlet, useLocation} from 'react-router-dom';

import {motion} from 'framer-motion';

const MessageLayout = () => {
  const {pathname} = useLocation();
  return (
    <>
      <div className="container vh-100">
        <motion.div
          key={pathname}
          initial={{opacity: 0, y: '100%'}}
          animate={{opacity: 1, y: 0}}
          exit={{opacity: 0, y: '-100%'}}
          transition={{duration: 0.2}}
          className="w-100 h-100"
        >
          <Outlet />
        </motion.div>
        <div id="message-footer"></div>
      </div>
    </>
  );
};

export default MessageLayout;
